import React, { useState } from 'react';
import { LinkButton } from '../../../CommonComponents/Button';
import Tooltip from '../../../CommonComponents/Tooltip';
import { ContactModal } from './components/ContactModal/ContactModal';
import { DemoModal } from './components/DemoModal/DemoModal';
import { HelpModal } from './components/HelpModal/HelpModal';

enum ModalStep {
  Help = 'Help',
  Demo = 'Demo',
  Contact = 'Contact',
}

export const Help = () => {
  const [modalStep, setModalStep] = useState<ModalStep | null>(null);

  return (
    <>
      <li className="button-item">
        <div className="button-item__container">
          <Tooltip tag="div" tooltipchildren="Help" orientation="bottom">
            <LinkButton
              prependIcon="fa fa-question-circle"
              size="big"
              className="right-buttons__button"
              aria-label="help"
              onClick={() => setModalStep(ModalStep.Help)}
              style={{ marginBottom: 4 }}
            />
          </Tooltip>
        </div>
      </li>

      {modalStep === ModalStep.Help && (
        <HelpModal
          onClose={() => setModalStep(null)}
          onDemo={() => setModalStep(ModalStep.Demo)}
          onContact={() => setModalStep(ModalStep.Contact)}
        />
      )}

      {modalStep === ModalStep.Demo && (
        <DemoModal onClose={() => setModalStep(null)} onBack={() => setModalStep(ModalStep.Help)} />
      )}

      {modalStep === ModalStep.Contact && (
        <ContactModal
          onClose={() => setModalStep(null)}
          onBack={() => setModalStep(ModalStep.Help)}
        />
      )}
    </>
  );
};
